import axios from 'axios';
import Vue from 'vue'

export default {

    addClaim(subject, message){
        return axios.post('/api/claim/add', {id:null, subject: subject, message : message})
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Message envoyé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    changeStatus(id, status){
        return axios.post('/api/claim/change-status', {id:id, status: status})
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Etat de la réclamation est modifé");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getClaims (page, pageSize) {
        return axios.get('/api/claim/list', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

